(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/usystem-button.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/usystem-button.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.UsystemButton = Backbone.Model.extend({
    defaults: {
      nrOfUHedges: 0,
      systemUSigns: 0,
      cssClass: 'stryktipset',
      isUsystem: false,
      showBgLayer: false
    },

    initialize: function() {
      this.listenTo(svs.tipset.models.systems, 'change', this.updateSystem);

      var isUSystem = this.isUsystem();

      if (isUSystem) {
        this.listenTo(
          svs.tipset.collections.matchlist,
          'buttonBet resetAll',
          this.update
        );
        this.set({
          isUsystem: isUSystem,
          nrOfUHedges: svs.tipset.collections.matchlist.getNrOfUMarks(),
          systemUSigns: svs.tipset.models.systems.getCurrentSystem().uSigns,
          cssClass: svs.tipset.models.gameDefinitions.get('htmlClass')
        });
      }
    },

    update: function() {
      this.set({
        nrOfUHedges: svs.tipset.collections.matchlist.getNrOfUMarks(),
        systemUSigns: svs.tipset.models.systems.getCurrentSystem().uSigns
      });
    },

    updateSystem: function() {
      var isUSystem = this.isUsystem();
      if (isUSystem) {
        this.set({
          isUsystem: isUSystem,
          systemUSigns: svs.tipset.models.systems.getCurrentSystem().uSigns
        });
      } else {
        this.destroy();
      }
    },

    isUsystem: function() {
      var hasSystems =
          svs.utils.ns.isNamespace('svs.tipset.models.systems') &&
          svs.tipset.models.systems.getCurrentSystem(),
        isUSustem = hasSystems
          ? svs.tipset.models.systems.getCurrentSystem().type ==
            svs.tipset.constants.SYSTEM_TYPE.U_SYSTEM
          : false;

      return isUSustem;
    }
  });
})(Backbone, _, svs);

 })(window);